import styled from "@emotion/styled";

export const DetailsRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 25px;
  @media (max-width: 767px) {
    display: block;
  }
`;

export const LeftDetailsCol = styled.div`
  display: flex;
  gap: 25px;
  align-items: center;
  white-space: nowrap;
  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

export const RightDetailsCol = styled.div``;

export const ThumbnailCol = styled.div`
  width: 8rem;
`;

export const ThumbnailWrapper = styled.div`
  position: relative;
`;

export const Thumbnail = styled.img`
  width: 100%;
  border-radius: 0.5rem;
  height: 130px;
  width: 130px;
  object-fit: cover;
`;

export const InformationCol = styled.div`
  align-items: center;
  @media (max-width: 767px) {
    padding-top: 0.9375rem;
  }
`;

export const Name = styled.h2`
  font-family: "Poppins", sans-serif;
`;

export const ProgressTitle = styled.span`
  font-family: "Poppins", sans-serif;
  font-size: 0.75rem;
  color: grey;
  text-transform: uppercase;
  padding-top: 0.625rem;
  display: block;
`;

export const VerifiedIcon = styled.span`
  color: #2f8de4;
`;

export const ProgressBarWrapper = styled.div`
  margin-top: 0.4688rem;
  max-width: 21.875rem;
`;

export const ButtonsCol = styled.div`
  justify-content: flex-end;
  @media (max-width: 767px) {
    display: block;
    text-align: left;
    padding-top: 0.9375rem;
    button {
      width: 100%;
      &:last-of-type {
        margin-top: 0.9375rem;
      }
    }
  }
`;

export const TitleBadge = styled.span`
  font-size: 0.875rem;
  padding: 0.5rem 0.9375rem;
  color: #2f8de4 !important;
  font-size: 0.75rem;
  background-color: #e5f0f9;
  border-radius: 0.5rem;
  position: relative;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  display: inline-block;
`;

export const DetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 767px) {
    text-align: center;
  }
`;

export const BadgeWrapper = styled.div`
  display: inline-block;
  margin-bottom: 12.5px;
`;

export const ChangePictureButton = styled.button`
  position: absolute;
  right: 10px;
  bottom: 10px;
  z-index: 21;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #2f8de4;
  border: none;
  color: #fff;
`;

export const FileUploadButton = styled.input`
  display: none;
`;
